import React, {useState, useEffect} from "react";
import {isAuthenticated} from "./helper"
import {  useHistory } from "react-router-dom";
import AppTheme from "../colors";
import SESTransport from "nodemailer/lib/ses-transport";

const CreatePost = () => {
    const theme = JSON.parse(localStorage.getItem("theme"));
    const currentTheme =  AppTheme["light"]
    const history = useHistory()
    const [title, setTitle] = useState("")
    const [body, setBody] = useState("")
    const [image, setImage] = useState("")
    const [url, setUrl] = useState("")
    const {user, token} = isAuthenticated();
    const [error, setError] = useState(false)
    const [processing, setProcessing] = useState(false)
    useEffect(()=> {
        if(url){
            setProcessing(true)
            fetch(`${process.env.REACT_APP_BACKEND}/createpost/${user._id}`, {
            method:"POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                title, body, url
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log(data);
            if(data.error){
                console.log(data.error)
                setError(data.error)
            }
            else{
                history.push("/")
            }
        })
        .catch(err => console.log(err))
        }
    }, [url])
    const postDetails = () => {
        if(!image){
            setError("Please add all the fields")
            return ;
        }
        setProcessing(true)
        const data = new FormData()
        data.append("file", image)
        data.append("upload_preset", "socioroorkee")
        data.append("cloud_name", "dhwaj")
        fetch("https://api.cloudinary.com/v1_1/dhwaj/image/upload", {
            method: "POST",
            body: data
        })
        .then(res => res.json())
        .then(data => {
            setUrl(data.secure_url) 
        })
        .catch(err => console.log(err))
    }
    const errorMessege = () => (
        <div className="row">
            <div className="col s12 center-align">
                <div className="card-panel red white-text" style={{display: error ? "" : "none"}}>
                    {error}
                </div>
            </div>
        </div>
    )

    return(
        <div className="row"   >
            <div className="col s12">
                <div className="card input-filed input-field" style={{
                    margin:"30px auto",
                    maxWidth:"500px",
                    padding:"20px",
                    textAlign:"center",
                    backgroundColor: `${currentTheme.navColor}`, color: `${currentTheme.textColor}`
                }}>
                {errorMessege()}
                    <input type="text" placeholder="title" value={title} onChange={(e) => setTitle(e.target.value)}  style={{color: `${currentTheme.textColor}`}} />
                    <input type="text" placeholder="body" value={body} onChange={(e) => setBody(e.target.value)}  style={{color: `${currentTheme.textColor}`}} />
                    <div className="file-field input-field">
                        <div className="btn #64b5f6 blue darken-1">
                            <span>Upload Image</span>
                            <input type="file" onChange={e => setImage(e.target.files[0])}  style={{color: `${currentTheme.textColor}`}}  />
                        </div>
                        <div className="file-path-wrapper"> 
                            <input className="file-path validate" type="text"/>
                        </div>
                    </div>
                    <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={postDetails}>{processing ? 'Submitting...' : 'Submit Post'} </button>
                </div>
            </div>
        </div>
        
    )
}

export default CreatePost;